const base64Parser = require("image-to-base64");

export default new class ImageService {

    private b64Parse = base64Parser;

    getBase64FromSrc(url): Promise<string> {
        return this.b64Parse(url);
    }
};
